export const ADD_COMP_DISCOUNT = 'ADD_COMP_DISCOUNT';
export const ADD_COMP_DISCOUNT_FULFILLED = 'ADD_COMP_DISCOUNT_FULFILLED';
export const ADD_COMP_DISCOUNT_REJECTED = 'ADD_COMP_DISCOUNT_REJECTED';

export const CLEAR_COMP_DISCOUNTS = 'CLEAR_COMP_DISCOUNTS';
export const CLEAR_COMP_DISCOUNTS_FULFILLED = 'CLEAR_COMP_DISCOUNTS_FULFILLED';
export const CLEAR_COMP_DISCOUNTS_REJECTED = 'CLEAR_COMP_DISCOUNTS_REJECTED';

export const FETCH_COMP_DISCOUNTS = 'FETCH_COMP_DISCOUNTS';
export const FETCH_COMP_DISCOUNTS_FULFILLED = 'FETCH_COMP_DISCOUNTS_FULFILLED';
export const FETCH_COMP_DISCOUNTS_REJECTED = 'FETCH_COMP_DISCOUNTS_REJECTED';

export const REMOVE_COMP_DISCOUNT = 'REMOVE_COMP_DISCOUNT';
export const REMOVE_COMP_DISCOUNT_FULFILLED = 'REMOVE_COMP_DISCOUNT_FULFILLED';
export const REMOVE_COMP_DISCOUNT_REJECTED = 'REMOVE_COMP_DISCOUNT_REJECTED';

export const REMOVE_COMP_DISCOUNTS = 'REMOVE_COMP_DISCOUNTS';
export const REMOVE_COMP_DISCOUNTS_FULFILLED =
  'REMOVE_COMP_DISCOUNTS_FULFILLED';
export const REMOVE_COMP_DISCOUNTS_REJECTED = 'REMOVE_COMP_DISCOUNTS_REJECTED';
export const RESET_REMOVE_COMP_DISCOUNTS = 'RESET_REMOVE_COMP_DISCOUNTS';

export const RESET_COMP_DISCOUNTS = 'RESET_COMP_DISCOUNTS';

export const SUBMIT_COMP_DISCOUNTS = 'SUBMIT_COMP_DISCOUNT';
export const SUBMIT_COMP_DISCOUNTS_FULFILLED = 'SUBMIT_COMP_DISCOUNT_FULFILLED';
export const SUBMIT_COMP_DISCOUNTS_REJECTED = 'SUBMIT_COMP_DISCOUNT_REJECTED';
